import React, { useCallback } from "react";
import { Tag } from "../../tag/tag";
import { SelectProps } from "../select";
import { CSS_CLASSES } from "../select-css-classes";
import type { OptionsToString, SelectOption } from "../select.types";

export interface MultiSelectTokenListProps<S extends SelectOption = SelectOption> {
  selected: S[];
  onRemoveToken: (option: S) => void;
  optionToString: OptionsToString<S>;
  onClick: (e: any) => void;
  color?: SelectProps["color"];
  disabled?: boolean;
}

export const MultiSelectTokenList: React.FC<MultiSelectTokenListProps> = ({
  selected,
  onRemoveToken,
  optionToString,
  onClick,
  color = "interactive",
  disabled,
}) => {
  const consumePropagation = useCallback((e) => {
    e.stopPropagation();
  }, []);
  return selected && selected.length > 0 ? (
    <span className={CSS_CLASSES.SELECT_INPUT_TAG_LIST} onClick={(e) => !disabled && onClick(e)} tabIndex={-1}>
      {selected.map((option) => {
        return (
          <Tag
            color={color}
            removable
            disabled={disabled}
            onClick={consumePropagation}
            key={option.value}
            className={CSS_CLASSES.SELECT_INPUT_TAG_LIST_ITEM}
            onRemove={() => {
              onRemoveToken(option);
            }}
          >
            {optionToString(option)}
          </Tag>
        );
      })}
    </span>
  ) : null;
};
